module.exports = __webpack_public_path__ + "img/icon-automation-2.bdcf38c1.svg";